<script>
import { mapState, mapActions, mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import { dateTransform } from "@/utils/utils.js";

export default {
  listTableTopOffset: 268,
  props: ['pageNum', 'oldParams'],
  data() {
    return {
      tableColumns: [
        {
          label: "指令名称",
          prop: "instruction_name",
          overflow:true
        },
        {
          label: "指令码",
          prop: "instruction_code",
          overflow:true
        },
        {
          label: "编码格式",
          prop: "unicode",
          overflow:true
        },
        {
          label: "协议类型",
          prop: "send_type",
          overflow:true
        },
        {
          label: "创建时间",
          prop: "create_time",
          width: 130,
          overflow:true
        },
        {
          label: "是否启用",
          prop: "status",
          overflow:true
        },
        {
          label: "加入回车/换行",
          prop: "enter_space",
          width: 120,
          overflow:true
        },
        {
          label: "备注",
          prop: "remark",
          overflow:true
        },
        {
          label: "操作",
          prop: "operations",
          width: "180",
          overflow:false
        },
      ],
      formatMap: {
        // send_type: {
        //   '1': 'tcpip',
        //   '2': 'udp'
        // },
        unicode: {
          '1': '字符串',
          '2': '16进制'
        },
        enter_space: {
          '0': '否',
          '1': '回车',
          '2': '换行',
          '3': '回车/换行',
          '4': '换行/回车'
        },
        status: {
          'true': '是',
          'false': '否'
        }
      }
    };
  },
  computed: {
    ...mapState([
      'loginAccountInfo'
    ]),
    ...mapGetters(["directiveTableDatas", "directiveTableListTotal"]),
    formatTime() {
      return (val) => {
        return dateTransform(val) || "";
      };
    },
    isManage() {
      return !!this.loginAccountInfo.is_manage;
    },
    columns() {
      const currentColumns = this.tableColumns.concat([]);
      if (!this.isManage) {
        currentColumns.splice(5, 1);
      }
      return currentColumns;
    }
  },
  methods: {
    ...mapActions(['deleteTableData']),
    handleSelectionChange(val) {
      this.$emit("selectChange", val);
    },
    getTableData(params) {
      this.$emit("getDatas", params);
    },
    getFormatName(key, val) {
      return this.$tt(this.formatMap[key][val] || '');
    },
    handleEdit(row) {
      let url = '/publicResource/publicDirective/edit?id=' + row.id;
      if (this.oldParams.company_id) {
        url += '&company_id=' + this.oldParams.company_id;
      }
      if (this.oldParams.public_type_id) {
        url += '&public_type_id=' + this.oldParams.public_type_id;
      }
      this.$router.push(url);
    },
    handleView(row) {
      let url = '/publicResource/publicDirective/view?id=' + row.id;
      if (this.oldParams.company_id) {
        url += '&company_id=' + this.oldParams.company_id;
      }
      if (this.oldParams.public_type_id) {
        url += '&public_type_id=' + this.oldParams.public_type_id;
      }
      this.$router.push(url);
    },
    async deleteData(row) {
      try {
        this.$changeLoadingState(true);
        await this.deleteTableData({ids: [row.id]});
        this.$changeLoadingState(false);
        this.getTableData();
      } catch (error) {
        console.log(error);
        this.$changeLoadingState(false);
      }
    }
  },
  components: {
    Pagination,
  },
};
</script>
<template>
  <div>
    <el-table
      :data="directiveTableDatas"
      style="width: 100%"
      class="projectsTable"
      border
      :max-height="listTableMaxHeight"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        v-for="c in columns"
        :key="c.prop"
        :label="$tt(c.label)"
        :width="$listColWidth(c)"
        :min-width="$listColMinWidth(c)"
        :prop="$listColProp(c)"
        :sortable="$listSortable(c)"
        :class-name="$listColClass(c)"
        :label-class-name="$listColClass(c)"
        :fixed="$listColFixed(c)"
        :show-overflow-tooltip="$listOverflow(c)"
      >
        <template slot-scope="scope">
          <div v-if="c.prop.indexOf('time') > -1">
            {{ formatTime(scope.row[c.prop]) }}
          </div>
          <div v-else-if="!!formatMap[c.prop]">
            {{ getFormatName(c.prop, scope.row[c.prop]) }}
          </div>
          <div class="table-ops" v-else-if="c.prop == 'operations'">
            <el-button
              v-if="!isManage"
              size="mini"
              type="text"
              icon="el-icon-view"
              @click="handleView(scope.row)"
            >
              {{ $tt("查看") }}
            </el-button>
            <el-button
              v-if="isManage"
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
            >
              {{ $tt("编辑") }}
            </el-button>
            <el-popconfirm
              v-if="isManage"
              :title="$tt('确定要删除当前数据吗？')"
              @confirm="deleteData(scope.row)"
            >
              <el-button
                slot="reference"
                type="text"
                class="table-op-danger"
                size="mini"
                icon="el-icon-delete"
              >
                {{ $tt("删除") }}
              </el-button>
            </el-popconfirm>
          </div>
          <span v-else>{{ scope.row[c.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-if="directiveTableListTotal > 0"
      :handleSizeChange="
        (v) => {
          this.getTableData({ page_size: v, page_num: 1 });
        }
      "
      :handleCurrentPageChange="
        (v) => {
          this.getTableData({ page_num: v });
        }
      "
      :total="directiveTableListTotal"
      :pageNum="pageNum"
    />
  </div>
</template>